import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';

import { patientTheme } from './mui-theme';
import {
  PaSurveyHomePage as V2PaSurveyHomePage,
  PaSurveyEndPage as V2PaSurveyEndPage,
  PaSurveyPausePage as V2PaSurveyPausePage,
  PaSurveyTerminatedPage as V2PaSurveyTerminatedPage,
  PaAthenaInfoCheck as V2PaAthenaInfoCheck,
  PaSurveyTreePage as V2PaSurveyTreePage,
  V2PaAdhocHomePage,
  V2PaAdhocEndPage,
} from '../v2/pages/patient/survey';

export default function AppRoutesPatientV2() {
  return (
    <ThemeProvider theme={patientTheme}>
      <Routes>
        <Route path=':orgId/:shortId/athena-check' element={<V2PaAthenaInfoCheck />} />
        <Route path=':orgId/:shortId/adhoc/:adhocId/finished' element={<V2PaAdhocEndPage />} />
        <Route path=':orgId/:shortId/adhoc/:adhocId' element={<V2PaAdhocHomePage />} />
        <Route path=':orgId/:shortId/finished' element={<V2PaSurveyEndPage />} />
        <Route path=':orgId/:shortId/terminated' element={<V2PaSurveyTerminatedPage />} />
        <Route path=':orgId/:shortId/pause' element={<V2PaSurveyPausePage />} />
        <Route path=':orgId/:shortId/addon/:referralMessageId' element={<V2PaSurveyHomePage />} />
        <Route path=':orgId/:shortId/:treeKey' element={<V2PaSurveyTreePage />} />
        <Route path=':orgId/:shortId' element={<V2PaSurveyHomePage />} />
      </Routes>
    </ThemeProvider>
  );
}
